import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  useLocation,
  useNavigate,
  useSearchParams,
  useParams,
  Link,
} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Button,
  Container,
  Form,
  Modal,
  Nav,
  Table,
  Badge,
} from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';
import Select from 'react-select';
import {
  ActionButtons,
  Loader,
  SectionHeader,
  VerticalTabs,
  VerticalTabPane,
  addStatusToast,
  InputNumber,
  InputText,
  PaginationComponent,
  DeleteConfirmation,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { LOADING_STATUS, LOCALES } from '../../common/constants';
import {
  getAllRolesAsync,
  selectAllRoles,
  selectRolesLoadingStatus,
  getAcountDetailsFromDbAsync,
  selectAccountDetailsLoadingStatus,
  selectAccountDetailsFromDb,
  getAccountRolesFromDbAsync,
  getAllCustomerGroupsAsync,
  selectCustomerGroupsLoadingStatus,
  getVatSettingsAsync,
  selectUserRoles,
  updateAccountDataAsync,
  AccountUpdateData,
  ContactUpdateData,
  AddressUpdateData,
  EmailUpdateData,
  PhoneUpdateData,
  AccountDetailsFromDb,
  AddressResponse,
  EmailResponse,
  PhoneResponse,
  getOfficerSettingsAsync,
  CustomerSettingsResponse,
  getCustomerSettingsAsync,
  selectCustomerSettings,
  UpdateCustomerSettinsAsync,
  selectCustomerGroups,
  UpdateBookingNoteSettinsAsync,
  BookingNoteSettingsUpdateData,
  CustomerSettingsUpdateData,
  OmaLiittymaResponse,
  OfficerResponse,
  BankSettingsResponse,
  BookingNoteSettingsResponse,
  UpdateVatSettinsAsync,
  VatSettingsResponse,
  VatSettingsUpdateData,
  selectVatData,
  selectCustomerBookingsStatus,
  selectCustomerBookingsPagination,
  selectCustomerBookings,
  getCustomerBookingsAsync,
  GetCustomerBookingsQuery,
  markAccountDeletedAsyncAsync,
  getAllCustomersFromDbAsync,
} from '../Users/identityUsersSlice';
import {
  getCountriesAsync,
  selectCountryItems,
} from '../countries/countriesSlice';
import InputCheck from '../../common/components/Input/InputCheck';
import customerGroups from './CustomerGroups';
import {
  setWebShopCustomerState,
  WebShopCustomerItem,
} from '../bookings/bookingsSlice';
import {
  BookingType,
  bookingTypeTranslations,
} from '../bookings/Constants/BookingTypeEnum';

function CustomerDetails() {
  const location = useLocation();
  const { from } = location.state || {};
  const [searchParams, setSearchParams] = useSearchParams();
  const backLinkUrl =
    from ||
    `/customers/search${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
  const params = useParams();
  const dispatch = useAppDispatch();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const allRoles = useAppSelector(selectAllRoles);
  const userRoles = useAppSelector(selectUserRoles);
  const customerBookings = useAppSelector(selectCustomerBookings);
  const customerBookingsLoadingStatus = useAppSelector(
    selectCustomerBookingsStatus,
  );
  const customerBookingsPagination = useAppSelector(
    selectCustomerBookingsPagination,
  );
  const rolesStatus = useAppSelector(selectRolesLoadingStatus);
  const countries = useAppSelector(selectCountryItems);
  const allGroups = useAppSelector(selectCustomerGroups);
  const allGroupsLoadingStatus = useAppSelector(
    selectCustomerGroupsLoadingStatus,
  );
  const accountDetails = useAppSelector(selectAccountDetailsFromDb);
  const customerSettings = useAppSelector(selectCustomerSettings);
  const accountLoadingStatus = useAppSelector(
    selectAccountDetailsLoadingStatus,
  );
  const vatSettings = useAppSelector(selectVatData);
  const customerBookingsInitFilter = {
    customerId: params.customerId,
    pageNumber: 1,
    pageSize: 30,
  } as GetCustomerBookingsQuery;
  const [customerBookingsFilter, setCustomerBookingsFilter] =
    useState<GetCustomerBookingsQuery>(customerBookingsInitFilter);
  const [isAddressModalVisible, setIsAddressModalVisible] =
    useState<boolean>(false);
  const [isPhoneModalVisible, setIsPhoneModalVisible] =
    useState<boolean>(false);
  const [isEMailModalVisible, setIsEMailModalVisible] =
    useState<boolean>(false);

  function getIsCustomer() {
    const filteredRoles =
      allRoles != null && allRoles.rolesList != null && userRoles != null
        ? allRoles.rolesList.filter(
            ar => userRoles.includes(ar.id) && ar.name.includes('Customer'),
          )
        : null;
    return filteredRoles != null && filteredRoles.length > 0;
  }

  function getIsOfficer() {
    const filteredRoles =
      allRoles != null && allRoles.rolesList != null
        ? allRoles.rolesList.filter(
            ar =>
              userRoles.includes(ar.id) && ar.name.includes('Administrator'),
          )
        : null;
    return filteredRoles != null && filteredRoles.length > 0;
  }

  const Tabs: string[] = [
    'Perustiedot',
    'Yhteystiedot',
    'Roolit',
    'Asiakaskohtaiset asetukset',
    'Alv asetukset',
    'Varaukset',
  ];
  const [activeTab, setActiveTab] = useState<string>(Tabs[0]);
  const [editedCustomerSettings, setEditedCustomerSettings] =
    useState<CustomerSettingsResponse>({
      id: '',
      customerNumber: null,
      accountId: '',
      customerGroupId: '',
      additionalInfo: '',
      advanceInvoiceDueDateOffsetDays: null,
      billingLocale: '',
      bookingOfficeTenantId: '',
      complaints: '',
      discountVatP: null,
      domesticPriceMultiplier: null,
      finalInvoiceDueDateOffsetDays: null,
      invoiceByEmail: false,
      invoiceByInternet: false,
      invoiceByMail: false,
      isAdvanceInvoiceAllowed: false,
      isDeleted: false,
      isRegularCustomer: false,
      isDomestic: false,
      useCancelInsurance: false,
      isSkiCenterCustomer: false,
      marketingAuthorizationViaEmail: false,
      fullEmailMarketingAllowed: false,
      marketingAuthorizationViaSms: false,
      officeFee: false,
      travelAgencyCommission: null,
      travelAgencyVat: null,
    } as CustomerSettingsResponse);
  const handlePaginationClickCustomers = (Page: number) => {
    const paginatedFiltering = customerBookingsFilter;
    paginatedFiltering.pageNumber = Page;
    setCustomerBookingsFilter(paginatedFiltering);
    dispatch(getCustomerBookingsAsync(paginatedFiltering));
  };
  const [editedEmail, setEditedEmail] = useState<EmailResponse>({
    id: '',
    description: '',
    emailAddress: '',
    isPrimary: false,
  } as EmailResponse);
  const history = useNavigate();
  const handleEditBookingClick = selectedOption => {
    window.open(`/bookings/${selectedOption.id}`, '_blank');
  };
  const [editedVatSettings, setEditedVatSettings] =
    useState<VatSettingsResponse>({
      id: '',
      accountId: '',
      hetu: '',
      otherVatCode: '',
      paysVat: false,
      yCode: '',
    } as VatSettingsResponse);
  function getBookingTypeTranslation(
    bookingType: BookingType,
    locale: 'en' | 'fi',
  ): string {
    return bookingTypeTranslations[locale][bookingType] || 'Unknown';
  }

  const bookingListItems = useMemo(() => {
    return customerBookingsLoadingStatus === LOADING_STATUS.IDLE ? (
      customerBookings?.map(item => (
        <>
          <tr key={item.id}>
            <td>
              <Link
                className="d-block"
                to={`/bookings/${item.id}`}
                state={{ backUrl: '/?tab=tab2' }}
              >
                {item.bookingNumber}
              </Link>
            </td>
            <td>
              <Link
                className="d-block"
                to={`/bookings/${item.id}`}
                state={{ backUrl: '/?tab=tab1' }}
              >
                {new Date(item.startDate).toLocaleDateString('fi-FI')}
                {' - '}
                {new Date(item.endDate).toLocaleDateString('fi-FI')}
              </Link>
            </td>
            {/* <td> */}
            {/*  <Link */}
            {/*    className="d-block" */}
            {/*    to={`/bookings/${item.id}`} */}
            {/*    state={{ backUrl: '/?tab=tab2' }} */}
            {/*  > */}
            {/*    {getBookingTypeTranslation(item., 'fi')} */}
            {/*  </Link> */}
            {/* </td> */}
            <td>
              <Link
                className="d-block"
                to={`/bookings/${item.id}`}
                state={{ backUrl: '/?tab=tab2' }}
              >
                {item.payerFirstName} {item.payerLastName}
              </Link>
            </td>
            <td>
              <Link
                className="nav-link"
                to={`/bookings/${item.id}`}
                state={{ backUrl: '/?tab=tab2' }}
              >
                {item.itemName}
              </Link>
            </td>
            <td>
              {(() => {
                let badge;
                if (item.isCancelled) {
                  badge = (
                    <Link
                      className="d-block"
                      to={`/bookings/${item.id}`}
                      state={{ backUrl: '/?tab=tab1' }}
                    >
                      <Badge bg="danger">Peruttu</Badge>
                    </Link>
                  );
                } else if (item.isConfirmed) {
                  badge = (
                    <Link
                      className="d-block"
                      to={`/bookings/${item.id}`}
                      state={{ backUrl: '/?tab=tab2' }}
                    >
                      <Badge bg="primary">Vahvistettu</Badge>
                    </Link>
                  );
                }
                return badge;
              })()}
            </td>
            <td>
              {item.price}
              {' €'}
            </td>
            <td>
              {item.purchasePrice}
              {' €'}
            </td>
          </tr>
          {item.additionalOrderItems.map((additionalItem, index) => (
            <tr key={additionalItem.id}>
              <td />
              <td>{additionalItem.itemName}</td>
              <td />
              <td />
              <td />
              <td>
                {additionalItem.price}
                {' €'}
              </td>
              <td>
                {additionalItem.purchasePrice}
                {' €'}
              </td>
            </tr>
          ))}
        </>
      ))
    ) : (
      <div />
    );
  }, [customerBookings, customerBookingsLoadingStatus]);
  const [editedPhone, setEditedPhone] = useState<PhoneResponse>({
    id: '',
    typeId: '',
    phoneNumber: '',
    description: '',
    isPrimary: false,
    bookingNoteBySms: false,
  } as PhoneResponse);

  const [editedAddress, setEditedAddress] = useState<AddressResponse>({
    id: null,
    postStreetAddress: '',
    postCity: '',
    postCode: '',
    isPrimary: false,
    description: '',
    additionalAddressLine: '',
    countryId: '',
  } as AddressResponse);

  const [editedRoles, setEditedRoles] = useState<string[]>([]);

  const [editedAccount, setEditedAccount] = useState<AccountDetailsFromDb>({
    id: '',
    addresses: [
      {
        id: '',
        postStreetAddress: '',
        postCity: '',
        postCode: '',
        isPrimary: false,
        description: '',
        additionalAddressLine: '',
        countryId: '',
      },
    ] as AddressResponse[],
    companyName: '',
    additionalInformation: '',
    description: '',
    emails: [
      {
        id: '',
        description: '',
        emailAddress: '',
        isPrimary: false,
      } as EmailResponse,
    ],
    firstName: '',
    lastName: '',
    phones: [
      {
        id: '',
        typeId: '',
        phoneNumber: '',
        description: '',
        isPrimary: false,
        bookingNoteBySms: false,
      } as PhoneResponse,
    ],
    www: '',
    subjectId: '',
  } as AccountDetailsFromDb);

  function resetData() {
    setEditedAccount({
      id: '',
      addresses: [
        {
          id: '',
          postStreetAddress: '',
          postCity: '',
          postCode: '',
          isPrimary: false,
          description: '',
          additionalAddressLine: '',
          countryId: '',
        },
      ] as AddressResponse[],
      companyName: '',
      additionalInformation: '',
      description: '',
      emails: [
        {
          id: '',
          description: '',
          emailAddress: '',
          isPrimary: false,
        } as EmailResponse,
      ],
      firstName: '',
      lastName: '',
      phones: [
        {
          id: '',
          typeId: '',
          phoneNumber: '',
          description: '',
          isPrimary: false,
          bookingNoteBySms: false,
        } as PhoneResponse,
      ],
      www: '',
      subjectId: '',
    } as AccountDetailsFromDb);
    setEditedVatSettings({
      id: '',
      accountId: '',
      hetu: '',
      otherVatCode: '',
      paysVat: false,
      yCode: '',
    } as VatSettingsResponse);
    setEditedPhone({
      id: '',
      typeId: '',
      phoneNumber: '',
      description: '',
      isPrimary: false,
      bookingNoteBySms: false,
    } as PhoneResponse);
    setEditedAddress({
      id: null,
      postStreetAddress: '',
      postCity: '',
      postCode: '',
      isPrimary: false,
      description: '',
      additionalAddressLine: '',
      countryId: '',
    } as AddressResponse);
    setEditedEmail({
      id: '',
      description: '',
      emailAddress: '',
      isPrimary: false,
    } as EmailResponse);
    setEditedRoles([]);
  }

  const initFetch = useCallback(() => {
    resetData();
    dispatch(getAcountDetailsFromDbAsync(params.customerId));
    dispatch(getAccountRolesFromDbAsync(params.customerId));
    dispatch(getVatSettingsAsync(params.customerId));
    dispatch(getCustomerBookingsAsync(customerBookingsFilter));
    dispatch(
      getAllCustomerGroupsAsync({
        PageSize: 100,
        PageNumber: 1,
        Culture: 'fi_FI',
        SearchString: null,
      }),
    );
    dispatch(getCustomerSettingsAsync(params.customerId)).then(res => {
      if (res.meta.requestStatus === 'fulfilled') {
        setEditedCustomerSettings(res.payload);
      }
    });
    dispatch(
      getCountriesAsync({
        PageNumber: 1,
        PageSize: 100000,
        searchString: '',
        culture: LOCALES.Fi,
      }),
    );
    dispatch(
      getAllRolesAsync({
        pageNumber: 1,
        pageSize: 10,
        culture: 'fi_FI',
        searchString: '',
      }),
    );
  }, [dispatch, params.customerId]);

  useEffect(() => {
    initFetch();
  }, [initFetch, params.customerId]);

  useEffect(() => {
    if (vatSettings != null) {
      setEditedVatSettings(vatSettings);
    }
  }, [vatSettings]);

  useEffect(() => {
    if (userRoles != null) {
      setEditedRoles(userRoles);
    }
  }, [userRoles]);

  useEffect(() => {
    if (customerSettings != null) {
      setEditedCustomerSettings(customerSettings);
    }
  }, [customerSettings]);
  function getItem(locale, keyId, item) {
    if (item != null && item.translations != null) {
      const found = item.translations.filter(
        a => a.locale === locale && a.keyId === keyId,
      );
      if (found && found[0] && found[0].text) {
        return found[0].text;
      }
    }
    return '';
  }
  const groupsList = allGroups.map(pvat => {
    return {
      value: pvat.id,
      label: getItem('fi_FI', 'CustomerGroupName', pvat),
    };
  });

  useEffect(() => {
    if (customerGroups != null) {
      setEditedCustomerSettings(customerSettings);
    }
  }, [customerGroups]);

  useEffect(() => {
    if (editedRoles != null) {
      setEditedRoles(editedRoles);
    }
  }, [editedRoles]);
  function isSelected(itemId) {
    if (editedRoles != null) {
      return editedRoles.some(s =>
        s.toUpperCase().includes(itemId.toUpperCase()),
      );
    }
    return false;
  }
  function getVatUpdateData() {
    const vatUpdateData = {
      id: editedVatSettings.id,
      hetu: editedVatSettings.hetu,
      accountId: editedAccount.id,
      otherVatCode: editedVatSettings.otherVatCode,
      paysVat: editedVatSettings.paysVat,
      yCode: editedVatSettings.yCode,
    } as VatSettingsUpdateData;

    return vatUpdateData;
  }
  function getUpdateData() {
    let accountUpdateData: AccountUpdateData;
    accountUpdateData = {
      id: null,
      contactUpdateData: null,
      accountsRoles: null,
    } as AccountUpdateData;

    if (editedAccount != null) {
      accountUpdateData = { ...accountUpdateData, id: editedAccount.id };
    }
    if (
      editedAccount != null &&
      (editedAccount.firstName != null ||
        editedAccount.lastName != null ||
        editedAccount.www != null ||
        editedAccount.companyName != null ||
        editedAccount.description != null ||
        editedAccount.additionalInformation != null)
    ) {
      accountUpdateData = {
        ...accountUpdateData,
        contactUpdateData: {
          firstName: editedAccount.firstName,
          companyName: editedAccount.companyName,
          addresses: null,
          description: editedAccount.description,
          additionalInformation: editedAccount.additionalInformation,
          emails: null,
          lastName: editedAccount.lastName,
          www: editedAccount.www,
          phones: null,
        },
      };
    } else {
      accountUpdateData = {
        ...accountUpdateData,
        contactUpdateData: {
          firstName: null,
          companyName: null,
          additionalInformation: null,
          addresses: null,
          description: null,
          emails: null,
          lastName: null,
          www: null,
          phones: null,
        } as ContactUpdateData,
      };
    }

    if (editedAccount != null && editedAccount.emails != null) {
      let contactdata = { ...accountUpdateData.contactUpdateData };
      contactdata = {
        ...contactdata,
        emails: editedAccount.emails.map(data => {
          return {
            id: data.id === 'new' ? null : data.id,
            isPrimary: data.isPrimary,
            description: data.description,
            emailAddress: data.emailAddress,
          } as EmailUpdateData;
        }),
      };
      accountUpdateData = {
        ...accountUpdateData,
        contactUpdateData: contactdata,
      };
    }

    if (editedAccount != null && editedAccount.phones != null) {
      let contactdata = { ...accountUpdateData.contactUpdateData };
      contactdata = {
        ...contactdata,
        phones: editedAccount.phones.map(data => {
          return {
            id: data.id === 'new' ? null : data.id,
            isPrimary: data.isPrimary,
            bookingNoteBySms: data.bookingNoteBySms,
            description: data.description,
            phoneNumber: data.phoneNumber,
            typeId: data.typeId,
          } as PhoneUpdateData;
        }),
      };
      accountUpdateData = {
        ...accountUpdateData,
        contactUpdateData: contactdata,
      };
    }

    if (editedAccount != null && editedAccount.addresses != null) {
      let contactdata = { ...accountUpdateData.contactUpdateData };
      contactdata = {
        ...contactdata,
        addresses: editedAccount.addresses.map(data => {
          if (data.id === 'new') {
            return {
              id: null,
              isPrimary: data.isPrimary,
              description: data.description,
              additionalAddressLine: data.additionalAddressLine,
              countryId: data.countryId,
              postCode: data.postCode,
              postCity: data.postCity,
              postStreetAddress: data.postStreetAddress,
            } as AddressUpdateData;
          }
          if (editedAddress.id === data.id) {
            return editedAddress;
          }
          return {
            id: data.id,
            isPrimary: data.isPrimary,
            description: data.description,
            additionalAddressLine: data.additionalAddressLine,
            countryId: data.countryId,
            postCode: data.postCode,
            postCity: data.postCity,
            postStreetAddress: data.postStreetAddress,
          } as AddressUpdateData;
        }),
      };
      accountUpdateData = {
        ...accountUpdateData,
        contactUpdateData: contactdata,
      };
    }
    if (userRoles != null) {
      const temproles = [...editedRoles];
      const updatedRoles = temproles.map(tr => tr);
      accountUpdateData = { ...accountUpdateData, accountsRoles: updatedRoles };
    }
    return accountUpdateData;
  }
  function getCustomerSettingsUpdateData() {
    return {
      id: editedCustomerSettings.id,
      accountId: editedCustomerSettings.accountId,
      additionalInfo: editedCustomerSettings.additionalInfo,
      advanceInvoiceDueDateOffsetDays:
        editedCustomerSettings.advanceInvoiceDueDateOffsetDays,
      billingLocale: editedCustomerSettings.billingLocale,
      customerNumber: editedCustomerSettings.customerNumber,
      complaints: editedCustomerSettings.complaints,
      bookingOfficeTenantId: editedCustomerSettings.bookingOfficeTenantId,
      customerGroupId: editedCustomerSettings.customerGroupId,
      discountVatP: editedCustomerSettings.discountVatP,
      domesticPriceMultiplier: editedCustomerSettings.domesticPriceMultiplier,
      finalInvoiceDueDateOffsetDays:
        editedCustomerSettings.finalInvoiceDueDateOffsetDays,
      invoiceByEmail: editedCustomerSettings.invoiceByEmail,
      invoiceByInternet: editedCustomerSettings.invoiceByInternet,
      invoiceByMail: editedCustomerSettings.invoiceByMail,
      isAdvanceInvoiceAllowed: editedCustomerSettings.isAdvanceInvoiceAllowed,
      isRegularCustomer: editedCustomerSettings.isRegularCustomer,
      isDomestic: editedCustomerSettings.isDomestic,
      useCancelInsurance: editedCustomerSettings.useCancelInsurance,
      isSkiCenterCustomer: editedCustomerSettings.isSkiCenterCustomer,
      marketingAuthorizationViaEmail:
        editedCustomerSettings.marketingAuthorizationViaEmail,
      fullEmailMarketingAllowed:
        editedCustomerSettings.fullEmailMarketingAllowed,
      marketingAuthorizationViaSms:
        editedCustomerSettings.marketingAuthorizationViaSms,
      officeFee: editedCustomerSettings.officeFee,
      travelAgencyCommission: editedCustomerSettings.travelAgencyCommission,
      travelAgencyVat: editedCustomerSettings.travelAgencyVat,
    } as CustomerSettingsUpdateData;
  }
  const handleDeleteUser = event => {
    console.log('handleDeleteUser called');
    const accountUpdateData = {
      id: editedAccount.id,
      contactUpdateData: null,
      accountsRoles: null,
    } as AccountUpdateData;
    dispatch(markAccountDeletedAsyncAsync(accountUpdateData)).then(res => {
      if (res.meta.requestStatus === 'fulfilled') {
        dispatch(
          addStatusToast({
            Message: `Käyttäjä on poistettu.`,
          }),
        );
        history('/customers/search');
      } else if (res.meta.requestStatus === 'rejected') {
        dispatch(
          addStatusToast({
            IsFailed: true,
            Message: `Käyttäjän poistamisessa tapahtui virhe.`,
          }),
        );
      }
    });
  };
  const onConfirmDelete = () => {
    setShowDeleteConfirm(false);
    handleDeleteUser(null);
  };
  const updateCustomerSettings = event => {
    const updateData = getCustomerSettingsUpdateData();
    if (
      updateData.customerGroupId == null ||
      updateData.customerGroupId === '' ||
      updateData.customerGroupId === undefined
    ) {
      dispatch(
        addStatusToast({
          Message: `Asiakasryhmä puuttuu`,
          IsFailed: true,
          Title: 'Tallennus epäonnistui',
        }),
      );
      return;
    }
    dispatch(UpdateCustomerSettinsAsync(updateData));
    dispatch(
      addStatusToast({
        Message: `Asiakaskohtaiset asetukset on tallennettu.`,
      }),
    );
  };
  function addRemoveSelectedRole(event, roleId) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value === true) {
      if (
        editedRoles.some(s =>
          s.toUpperCase().includes(roleId.toUpperCase()),
        ) === true
      ) {
        return;
      }

      const tempuserRoles = [...editedRoles, roleId.toUpperCase().toString()];
      setEditedRoles(tempuserRoles);
    } else if (
      editedRoles.some(s => s.toUpperCase().includes(roleId.toUpperCase()))
    ) {
      const itemIndex = editedRoles.findIndex(o =>
        o.toUpperCase().includes(roleId.toUpperCase()),
      );
      if (itemIndex > -1) {
        const tempUserRoles = [...editedRoles];
        tempUserRoles.splice(itemIndex, 1);
        setEditedRoles(tempUserRoles);
      }
    }
  }

  const rolesSelectOptions = allRoles?.rolesList.map(item => (
    <Form.Group controlId={item.id} className="mb-24" key={item.id}>
      <Form.Check
        className="mb-24"
        label={item.description ?? item.name}
        name={item.name}
        checked={isSelected(item.id.toUpperCase())}
        onChange={event => addRemoveSelectedRole(event, item.id)}
      />
    </Form.Group>
  ));
  const handleSelectChangeAddress = selectedOption => {
    if (
      editedAccount.addresses != null &&
      selectedOption != null &&
      selectedOption.id != null
    ) {
      const data = editedAccount.addresses.filter(
        add => add.id === selectedOption.id,
      );
      if (data.length > 0) {
        setEditedAddress(data[0]);
      }
    }
  };
  const handleInputChangeVat = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    const tempdata = { ...editedVatSettings, [name]: value };
    setEditedVatSettings(tempdata);
  };

  const updateVatSettings = event => {
    const updateData = getVatUpdateData();
    dispatch(UpdateVatSettinsAsync(updateData));
    dispatch(
      addStatusToast({
        Message: `Alv asetukset on tallennettu.`,
      }),
    );
  };
  const handleSelectChangePhone = selectedOption => {
    if (
      editedAccount.phones != null &&
      selectedOption != null &&
      selectedOption.id != null
    ) {
      const data = editedAccount.phones.filter(
        add => add.id === selectedOption.id,
      );
      if (data.length > 0) {
        setEditedPhone(data[0]);
      }
    }
  };
  const handleSelectChangeEmail = selectedOption => {
    if (
      editedAccount.emails != null &&
      selectedOption != null &&
      selectedOption.id != null
    ) {
      const data = editedAccount.emails.filter(
        add => add.id === selectedOption.id,
      );
      if (data.length > 0) {
        setEditedEmail(data[0]);
      }
    }
  };
  const handleEditAddressClick = selectedOption => {
    handleSelectChangeAddress(selectedOption);
    setIsAddressModalVisible(true);
  };

  const handleEditPhoneClick = selectedOption => {
    handleSelectChangePhone(selectedOption);
    setIsPhoneModalVisible(true);
  };

  const handleEditEmailClick = selectedOption => {
    handleSelectChangeEmail(selectedOption);
    setIsEMailModalVisible(true);
  };

  function removeAddress(removedItem) {
    if (editedAccount != null && editedAccount.addresses != null) {
      const tempaddresses = editedAccount.addresses.filter(
        item => item.id !== removedItem.id,
      );

      const storedAccount = {
        ...editedAccount,
        addresses: tempaddresses,
      };
      setEditedAccount(storedAccount);
    }
  }

  function removePhone(removedItem) {
    if (editedAccount != null && editedAccount.phones != null) {
      const tempPhones = editedAccount.phones.filter(
        item => item.id !== removedItem.id,
      );

      const storedAccount = {
        ...editedAccount,
        phones: tempPhones,
      };
      setEditedAccount(storedAccount);
    }
  }
  const mystate = location.state as {
    payer: string;
    bookingId: string;
    bookingType: string;
    webshopCustomer: WebShopCustomerItem;
  }; // Type assertion for TypeScript
  function removeEmail(removedItem) {
    if (editedAccount != null && editedAccount.emails != null) {
      const tempEmail = editedAccount.emails.filter(
        item => item.id !== removedItem.id,
      );

      const storedAccount = {
        ...editedAccount,
        emails: tempEmail,
      };
      setEditedAccount(storedAccount);
    }
  }

  const accountAddressSelectOptions =
    accountLoadingStatus === LOADING_STATUS.IDLE &&
    editedAccount != null &&
    editedAccount.addresses != null ? (
      editedAccount?.addresses.map(item => (
        <tr key={item.id}>
          <td style={{ width: '100%' }}>
            <span>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.streetAddress && (
                  <span>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {mystate.webshopCustomer.streetAddress}
                    </div>
                  </span>
                )}
              {item.postStreetAddress ?? ''}
            </span>
          </td>
          <td style={{ width: '100%' }}>
            <span>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.postalCode && (
                  <span>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {mystate.webshopCustomer.postalCode}
                    </div>
                  </span>
                )}
              {item.postCode ?? ''}
            </span>
          </td>
          <td style={{ width: '100%' }}>
            <span>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.postCity && (
                  <span>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {mystate.webshopCustomer.postCity}
                    </div>
                  </span>
                )}
              {item.postCity ?? ''}
            </span>
          </td>
          <td style={{ width: 100 }}>
            <Button
              variant="outline-blue"
              size="sm"
              onClick={() => handleEditAddressClick(item)}
            >
              Muokkaa
            </Button>
          </td>
          <td className="pe-0">
            <Button
              size="sm"
              variant="danger"
              onClick={() => removeAddress(item)}
            >
              X
            </Button>
          </td>
        </tr>
      ))
    ) : (
      <div />
    );

  const accountPhonesSelectOptions =
    accountLoadingStatus === LOADING_STATUS.IDLE &&
    editedAccount != null &&
    editedAccount.phones != null ? (
      editedAccount?.phones.map(item => (
        <tr key={item.id}>
          <td style={{ width: '100%' }}>
            <span>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.phoneNumber && (
                  <span>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {mystate.webshopCustomer.phoneNumber}
                    </div>
                  </span>
                )}
              {item.phoneNumber ?? ''}
            </span>
          </td>
          <td style={{ width: '100%' }}>{item.typeId ?? ''}</td>
          <td style={{ width: 100 }}>
            <Button
              variant="outline-blue"
              size="sm"
              onClick={() => handleEditPhoneClick(item)}
            >
              Muokkaa
            </Button>
          </td>
          <td className="pe-0">
            <Button
              size="sm"
              variant="danger"
              onClick={() => removePhone(item)}
            >
              X
            </Button>
          </td>
        </tr>
      ))
    ) : (
      <div />
    );
  const handleInputChange = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    const tempdata = { ...editedAccount, [name]: value };
    setEditedAccount(tempdata);
  };

  const handleInputChangeCustomerSettings = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    const tempdata = { ...editedCustomerSettings, [name]: value };
    if (name === 'marketingAuthorizationViaEmail' && value === false) {
      tempdata.fullEmailMarketingAllowed = false;
    }
    setEditedCustomerSettings(tempdata);
  };

  useEffect(() => {
    if (accountDetails != null) {
      setEditedAccount(accountDetails);
    }
  }, [accountDetails]);
  const webshopCustomer = mystate?.webshopCustomer;
  const updateAccount = event => {
    console.log('updateAccount called:', sessionStorage.getItem('bookingId'));
    console.log('updateAccount called:', mystate);
    if (mystate === null && sessionStorage.getItem('bookingId') != null) {
      console.error(
        'renavigate to customer details with bookingId :',
        sessionStorage.getItem('bookingId'),
      );
      history(`/customers/details/${editedAccount.id}`, {
        state: {
          bookingId: sessionStorage.getItem('bookingId'),
          bookingType: sessionStorage.getItem('bookingType'),
        },
      });
    }
    const updateData = getUpdateData();
    // Sanity check some data

    if (
      updateData.contactUpdateData.firstName === '' &&
      updateData.contactUpdateData.lastName === ''
    ) {
      dispatch(
        addStatusToast({
          Message: `Nimitieto puuttuu`,
          IsFailed: true,
          Title: 'Tallennus epäonnistui',
        }),
      );
      return;
    }

    if (updateData.contactUpdateData.emails.length > 0) {
      let isPrimary = false;
      updateData.contactUpdateData.emails.map(email => {
        if (email.emailAddress != null && email.emailAddress !== '') {
          isPrimary = true;
        }
        return email;
      });
      if (!isPrimary) {
        dispatch(
          addStatusToast({
            Message: `Pää sähköposti tyhjä !!`,
            IsFailed: true,
            Title: 'Tallennus epäonnistui',
          }),
        );
        return;
      }
    }

    if (updateData.contactUpdateData.addresses.length <= 0) {
      dispatch(
        addStatusToast({
          Message: `Osoitetieto puuttuu !!`,
          IsFailed: true,
          Title: 'Tallennus epäonnistui',
        }),
      );
      return;
    }

    if (updateData.contactUpdateData.addresses.length > 0) {
      let isPrimary = false;
      updateData.contactUpdateData.addresses.map(email => {
        if (email.isPrimary) {
          isPrimary = true;
        }
        return email;
      });
      if (!isPrimary) {
        dispatch(
          addStatusToast({
            Message: `Pää osoitetieto puuttuu !!`,
            IsFailed: true,
            Title: 'Tallennus epäonnistui',
          }),
        );
        return;
      }
    }

    if (updateData.contactUpdateData.addresses.length > 0) {
      let isPrimary = false;
      updateData.contactUpdateData.addresses.map(email => {
        if (email.countryId != null && email.countryId !== '') {
          isPrimary = true;
        }
        return email;
      });
      if (!isPrimary) {
        dispatch(
          addStatusToast({
            Message: `Osoitetiedosta puuttuu maavalinta !!`,
            IsFailed: true,
            Title: 'Tallennus epäonnistui',
          }),
        );
        return;
      }
    }
    dispatch(updateAccountDataAsync(updateData)).then(res => {
      updateVatSettings(event);
    });
    dispatch(
      addStatusToast({
        Message: `Alv Tiedot on tallennettu.`,
      }),
    );
  };
  const pickCustomer = event => {
    // Determine booking context prioritizing sessionStorage but safely falling back to navigation state
    const ssBookingId = sessionStorage.getItem('bookingId') || '';
    const ssBookingType = sessionStorage.getItem('bookingType') || '';
    const hasStoredId = ssBookingId && ssBookingId.length > 1;

    const effectiveBookingId = hasStoredId ? ssBookingId : mystate?.bookingId;
    const effectiveBookingType = hasStoredId
      ? ssBookingType || mystate?.bookingType
      : mystate?.bookingType;

    if (effectiveBookingId) {
      console.log('setWebshopCustomer customerdetails null:');
      dispatch(setWebShopCustomerState(null));
      const bookingTypeQuery = effectiveBookingType
        ? `?bookingType=${effectiveBookingType}`
        : '';
      history(
        `/bookings/${effectiveBookingId}/${editedAccount.id}${bookingTypeQuery}`,
        {
          state: {
            webshopCustomer,
          },
        },
      );
    }
  };
  const editAddresses = (
    addressesIn: AddressResponse[],
    valuedata: AddressResponse,
  ) => {
    if (valuedata.id !== 'new') {
      return addressesIn.map(item => {
        if (item.id === valuedata.id) {
          item = valuedata;
          if (valuedata.isPrimary) {
            return { ...item, isPrimary: true };
          }
        } else if (valuedata.isPrimary) {
          item.isPrimary = false;
        }
        return item;
      });
    }
    valuedata.id = crypto.randomUUID();
    setEditedAddress(valuedata);
    addressesIn = [...addressesIn, valuedata];
    return addressesIn;
  };

  const editEmails = (
    addressesIn: EmailResponse[],
    valuedata: EmailResponse,
  ) => {
    if (valuedata.id !== 'new') {
      return addressesIn.map(item => {
        if (item.id === valuedata.id) {
          item = valuedata;
          if (valuedata.isPrimary) {
            return { ...item, isPrimary: true };
          }
        } else if (valuedata.isPrimary) {
          item.isPrimary = false;
        }
        return item;
      });
    }
    valuedata.id = crypto.randomUUID();
    setEditedEmail(valuedata);
    addressesIn = [...addressesIn, valuedata];
    return addressesIn;
  };

  const editPhones = (
    addressesIn: PhoneResponse[],
    valuedata: PhoneResponse,
  ) => {
    if (valuedata.id !== 'new') {
      return addressesIn.map(item => {
        if (item.id === valuedata.id) {
          item = valuedata;
          if (valuedata.isPrimary) {
            return { ...item, isPrimary: true };
          }
        } else if (valuedata.isPrimary) {
          item.isPrimary = false;
        }
        return item;
      });
    }
    valuedata.id = crypto.randomUUID();
    setEditedPhone(valuedata);
    addressesIn = [...addressesIn, valuedata];
    return addressesIn;
  };

  const addAddress = () => {
    const newaddress = {
      isPrimary: false,
      postStreetAddress: '',
      additionalAddressLine: '',
      postCity: '',
      countryId: null,
      postCode: '',
      description: '',
      id: 'new',
    } as AddressResponse;
    setEditedAddress(newaddress);
    let { addresses } = editedAccount;
    addresses = editAddresses(addresses, newaddress);
    const storeAccount = { ...editedAccount, addresses };
    setEditedAccount(storeAccount);
    setIsAddressModalVisible(true);
  };

  const addEmail = () => {
    const newemail = {
      isPrimary: false,
      emailAddress: '',
      description: '',
      id: 'new',
    } as EmailResponse;
    setEditedEmail(newemail);
    let { emails } = editedAccount;
    emails = editEmails(emails, newemail);
    const customerDetailsStore = { ...editedAccount, emails };
    setEditedAccount(customerDetailsStore);
    setIsEMailModalVisible(true);
  };

  const addPhoneNumber = () => {
    const newPhone = {
      isPrimary: false,
      bookingNoteBySms: false,
      typeId: null,
      phoneNumber: '',
      description: '',
      id: 'new',
    } as PhoneResponse;
    setEditedPhone(newPhone);
    let { phones } = editedAccount;
    phones = editPhones(phones, newPhone);
    const customerDetailsStore = { ...editedAccount, phones };
    setEditedAccount(customerDetailsStore);
    setIsPhoneModalVisible(true);
  };
  const handleInputChangeEmail = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    setEditedEmail({
      ...editedEmail,
      [name]: value,
    });
    const editedEmailTemp = {
      ...editedEmail,
      [name]: value,
    };
    let { emails } = editedAccount;
    emails = editEmails(emails, editedEmailTemp);
    const accountDetailsStore = { ...editedAccount, emails };
    setEditedAccount(accountDetailsStore);
  };

  const handleInputChangePhone = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    setEditedPhone({
      ...editedPhone,
      [name]: value,
    });
    const editedPhoneTemp = {
      ...editedPhone,
      [name]: value,
    };
    let { phones } = editedAccount;
    phones = editPhones(phones, editedPhoneTemp);
    const accountDetailsStore = { ...editedAccount, phones };
    setEditedAccount(accountDetailsStore);
  };

  const countryOptions = countries.map(country => {
    return { value: country.id, label: country.name };
  });
  const handleInputChangeAddress = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    setEditedAddress({
      ...editedAddress,
      [name]: value,
    });
    const editedAddressTemp = {
      ...editedAddress,
      [name]: value,
    };
    let { addresses } = editedAccount;
    addresses = editAddresses(addresses, editedAddressTemp);
    const accountDetailsStore = { ...editedAccount, addresses };
    setEditedAccount(accountDetailsStore);
  };

  const handleSelectChange = (selectedOption, name) => {
    const newaddressData = { ...editedAddress };
    newaddressData[name] = selectedOption.value;
    setEditedAddress(newaddressData);
  };

  const handleSelectChangeCustomerGroup = (selectedOption, name) => {
    const newaddressData = { ...editedCustomerSettings };
    newaddressData[name] = selectedOption.value;
    setEditedCustomerSettings(newaddressData);
  };

  const accountEmailsSelectOptions =
    accountLoadingStatus === LOADING_STATUS.IDLE &&
    editedAccount != null &&
    editedAccount.emails != null ? (
      editedAccount?.emails.map(item => (
        <tr key={item.id}>
          <td style={{ width: '100%' }}>
            <span>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.email && (
                  <span>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {mystate.webshopCustomer.email}
                    </div>
                  </span>
                )}
              {item.emailAddress ?? ''}
            </span>
          </td>
          <td style={{ width: 100 }}>
            <Button
              variant="outline-blue"
              size="sm"
              onClick={() => handleEditEmailClick(item)}
            >
              Muokkaa
            </Button>
          </td>
          <td className="pe-0">
            <Button
              size="sm"
              variant="danger"
              onClick={() => removeEmail(item)}
            >
              X
            </Button>
          </td>
        </tr>
      ))
    ) : (
      <div />
    );
  function getBackLinkUrl() {
    const webshopCustomerFromSession =
      sessionStorage.getItem('webshopCustomer');
    const bookingId = sessionStorage.getItem('bookingId');
    history(
      `/customers/search${searchParams.toString() ? `?${searchParams.toString()}` : ''}`,
      {
        state: {
          webshopCustomer: webshopCustomerFromSession,
          bookingId,
        },
      },
    );
  }

  return (
    <>
      <Helmet>
        <title>Asiakasiedot</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={() => getBackLinkUrl()}
          Breadcrumbs={['Asiakkaat']}
          Title={`${
            accountLoadingStatus === LOADING_STATUS.IDLE
              ? `${editedCustomerSettings && editedCustomerSettings.customerNumber !== 0 && editedCustomerSettings.customerNumber !== undefined ? editedCustomerSettings.customerNumber : ''}
                 ${editedAccount.firstName} ${editedAccount.lastName}`
              : ''
          }`}
        />

        {accountLoadingStatus === LOADING_STATUS.LOADING && (
          <Loader IsLoading />
        )}

        {accountLoadingStatus === LOADING_STATUS.IDLE && (
          <VerticalTabs
            ActiveTab={activeTab}
            ChangeTab={setActiveTab}
            TabContainerId="customerTabs"
            Tabs={Tabs}
          >
            <VerticalTabPane IsActive={activeTab === Tabs[0]} Name={Tabs[0]}>
              {editedAccount != null && (
                <div>
                  {mystate != null &&
                    mystate.webshopCustomer !== null &&
                    mystate.webshopCustomer !== undefined &&
                    mystate.webshopCustomer.firstName && (
                      <span>
                        Verkkokaupan tiedot:
                        <div className="text-danger">
                          {mystate.webshopCustomer.firstName}
                        </div>
                      </span>
                    )}
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChange}
                      Id="firstName"
                      Name="firstName"
                      Value={editedAccount.firstName ?? ''}
                      IsRequired={false}
                      Label="Etunimi"
                    />
                  </div>
                  {mystate != null &&
                    mystate.webshopCustomer !== null &&
                    mystate.webshopCustomer !== undefined &&
                    mystate.webshopCustomer.lastName && (
                      <span>
                        Verkkokaupan tiedot:
                        <div className="text-danger">
                          {mystate.webshopCustomer.lastName}
                        </div>
                      </span>
                    )}
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChange}
                      Id="lastName"
                      Name="lastName"
                      Value={editedAccount.lastName ?? ''}
                      IsRequired={false}
                      Label="Sukunimi / Yritys"
                    />
                  </div>
                  {mystate != null &&
                    mystate.webshopCustomer !== null &&
                    mystate.webshopCustomer !== undefined &&
                    mystate.webshopCustomer.companyName && (
                      <span>
                        Verkkokaupan tiedot:
                        <div className="text-danger">
                          {mystate.webshopCustomer.companyName}
                        </div>
                      </span>
                    )}
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChange}
                      Id="companyName"
                      Name="companyName"
                      Value={editedAccount.companyName ?? ''}
                      IsRequired={false}
                      Label="Yhteyshenkilö"
                    />
                  </div>
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChange}
                      Id="description"
                      Name="description"
                      Value={editedAccount.description ?? ''}
                      IsRequired={false}
                      Label="Kuvaus"
                    />
                  </div>
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChange}
                      Id="additionalInformation"
                      Name="additionalInformation"
                      Value={editedAccount.additionalInformation ?? ''}
                      IsRequired={false}
                      Label="Lisätiedot"
                    />
                  </div>
                </div>
              )}
              <ActionButtons
                CancelButtonUrl={backLinkUrl}
                HandleSave={event => updateAccount(event)}
                HandleDelete={() => setShowDeleteConfirm(true)}
              />
              <DeleteConfirmation
                ShowModal={showDeleteConfirm}
                HideModal={() => setShowDeleteConfirm(false)}
                ConfirmDelete={() => onConfirmDelete()}
                Id={editedAccount?.id}
                Title="Poiston varmistaminen"
                Message="Haluatko varmasti poistaa asiakkaan ?"
                DeleteButtonText="Kyllä"
                CancelButtonText="Peruuta"
              />
              {mystate != null &&
                mystate.bookingId !== null &&
                mystate.bookingId !== '' && (
                  <ActionButtons
                    CancelButtonUrl={backLinkUrl}
                    HandleSave={event => pickCustomer(event)}
                    SaveButtonText="Valitse asiakas"
                    HideCancelButton
                  />
                )}
            </VerticalTabPane>
            <VerticalTabPane IsActive={activeTab === Tabs[1]} Name={Tabs[1]}>
              <div className="d-flex align-items-start mt-48">
                <h2 className="h5 h-md-4 flex-grow-1 me-16 mb-24">Osoitteet</h2>
                <Button size="sm" onClick={addAddress}>
                  <Icon Name="plus" CssClass="me-8" />
                  Lisää uusi
                </Button>
              </div>
              <div className="table-responsive-lg mb-48">
                <Table>
                  <tbody>{accountAddressSelectOptions}</tbody>
                </Table>
              </div>
              <div className="d-flex align-items-start mt-48">
                <h2 className="h5 h-md-4 flex-grow-1 me-16 mb-24">
                  Puhelinnumerot
                </h2>
                <Button size="sm" onClick={addPhoneNumber}>
                  <Icon Name="plus" CssClass="me-8" />
                  Lisää uusi
                </Button>
              </div>
              <div className="table-responsive-lg mb-48">
                <Table>
                  <tbody>{accountPhonesSelectOptions}</tbody>
                </Table>
              </div>
              <div className="d-flex align-items-start mt-48">
                <h2 className="h5 h-md-4 flex-grow-1 me-16 mb-24">
                  Sähköposti-osoitteet
                </h2>
                <Button size="sm" onClick={addEmail}>
                  <Icon Name="plus" CssClass="me-8" />
                  Lisää uusi
                </Button>
              </div>
              <div className="table-responsive-lg mb-48">
                <Table>
                  <tbody>{accountEmailsSelectOptions}</tbody>
                </Table>
              </div>
              <ActionButtons
                CancelButtonUrl={backLinkUrl}
                HandleSave={event => updateAccount(event)}
              />
            </VerticalTabPane>

            <VerticalTabPane IsActive={activeTab === Tabs[2]} Name={Tabs[2]}>
              {rolesStatus === LOADING_STATUS.IDLE && (
                <div>{rolesSelectOptions}</div>
              )}
              <ActionButtons
                CancelButtonUrl={backLinkUrl}
                HandleSave={event => updateAccount(event)}
              />
            </VerticalTabPane>
            {editedCustomerSettings != null &&
              rolesStatus === LOADING_STATUS.IDLE &&
              getIsCustomer() && (
                <VerticalTabPane
                  IsActive={activeTab === Tabs[3]}
                  Name={Tabs[3]}
                >
                  <div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="customerNumber"
                        Name="customerNumber"
                        Value={editedCustomerSettings.customerNumber ?? ''}
                        IsRequired={false}
                        Label="Asiakasnumero"
                        IsReadOnly
                      />
                    </div>
                    <div className="mb-24">
                      <InputText
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="additionalInfo"
                        Name="additionalInfo"
                        Value={editedCustomerSettings.additionalInfo ?? ''}
                        IsRequired={false}
                        Label="Lisätiedot"
                      />
                    </div>
                    <div className="mb-24">
                      <InputText
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="complaints"
                        Name="complaints"
                        Value={editedCustomerSettings.complaints ?? ''}
                        IsRequired={false}
                        Label="Huomautukset"
                      />
                    </div>
                    <div className="mb-24">
                      <Form.Label>Asiakasryhmä</Form.Label>
                      <Select
                        id="customerGroupId"
                        inputId="customerGroupId"
                        name="customerGroupId"
                        placeholder="Valitse asiakasryhmä"
                        isClearable
                        isSearchable
                        options={groupsList}
                        onChange={option =>
                          handleSelectChangeCustomerGroup(
                            option,
                            'customerGroupId',
                          )
                        }
                        value={groupsList.filter(
                          option =>
                            option.value ===
                            editedCustomerSettings.customerGroupId,
                        )}
                        classNames={{
                          control: state =>
                            'form-control form-control-react-select',
                        }}
                      />
                    </div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="advanceInvoiceDueDateOffsetDays"
                        Name="advanceInvoiceDueDateOffsetDays"
                        Value={
                          editedCustomerSettings.advanceInvoiceDueDateOffsetDays ??
                          ''
                        }
                        IsRequired={false}
                        Label="Ennakkolaskun eräpäiväsääntö"
                      />
                    </div>
                    <div className="mb-24">
                      <Select
                        inputId="billingLocale"
                        name="billingLocale"
                        placeholder="Valitse laskutuskieli"
                        isSearchable
                        options={[
                          { value: 'fi_FI', label: 'Suomi' },
                          { value: 'en_EN', label: 'Englanti' },
                        ]}
                        onChange={option =>
                          handleInputChangeCustomerSettings({
                            target: {
                              name: 'billingLocale',
                              value: option ? option.value : 'fi_FI',
                            },
                          })
                        }
                        value={
                          editedCustomerSettings.billingLocale
                            ? {
                                value: editedCustomerSettings.billingLocale,
                                label:
                                  editedCustomerSettings.billingLocale ===
                                  'fi_FI'
                                    ? 'Suomi'
                                    : 'Englanti',
                              }
                            : null
                        }
                        classNames={{
                          control: state =>
                            'form-control form-control-react-select',
                        }}
                      />
                    </div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="discountVatP"
                        Name="discountVatP"
                        Value={editedCustomerSettings.discountVatP ?? ''}
                        IsRequired={false}
                        Label="Alennuksen Alv%"
                      />
                    </div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="finalInvoiceDueDateOffsetDays"
                        Name="finalInvoiceDueDateOffsetDays"
                        Value={
                          editedCustomerSettings.finalInvoiceDueDateOffsetDays ??
                          ''
                        }
                        IsRequired={false}
                        Label="Loppulaskun eräpäiväsäätö"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="invoiceByMail"
                        Name="invoiceByMail"
                        Checked={editedCustomerSettings.invoiceByMail ?? false}
                        IsRequired={false}
                        Label="Lasku Postitse"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="invoiceByEmail"
                        Name="invoiceByEmail"
                        Checked={editedCustomerSettings.invoiceByEmail ?? false}
                        IsRequired={false}
                        Label="Lasku sähköPostitse"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="invoiceByInternet"
                        Name="invoiceByInternet"
                        Checked={
                          editedCustomerSettings.invoiceByInternet ?? false
                        }
                        IsRequired={false}
                        Label="Lasku Internet"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="isAdvanceInvoiceAllowed"
                        Name="isAdvanceInvoiceAllowed"
                        Checked={
                          editedCustomerSettings.isAdvanceInvoiceAllowed ??
                          false
                        }
                        IsRequired={false}
                        Label="Ennakkolasku sallittu"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="isRegularCustomer"
                        Name="isRegularCustomer"
                        Checked={
                          editedCustomerSettings.isRegularCustomer ?? false
                        }
                        IsRequired={false}
                        Label="Kanta-asiakas"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="isDomestic"
                        Name="isDomestic"
                        Checked={editedCustomerSettings.isDomestic ?? false}
                        IsRequired={false}
                        Label="Kotimainen asiakas"
                      />
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="useCancelInsurance"
                        Name="useCancelInsurance"
                        Checked={
                          editedCustomerSettings.useCancelInsurance ?? false
                        }
                        IsRequired={false}
                        Label="Peruutusturva"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="isSkiCenterCustomer"
                        Name="isSkiCenterCustomer"
                        Checked={
                          editedCustomerSettings.isSkiCenterCustomer ?? false
                        }
                        IsRequired={false}
                        Label="Hiihtokeskus asiakas"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="marketingAuthorizationViaEmail"
                        Name="marketingAuthorizationViaEmail"
                        Checked={
                          editedCustomerSettings.marketingAuthorizationViaEmail ??
                          false
                        }
                        IsRequired={false}
                        Label="Markkinointilupa email"
                      />
                      <InputCheck
                        IsReadOnly={
                          !editedCustomerSettings.marketingAuthorizationViaEmail
                        }
                        Checked={
                          (editedCustomerSettings.marketingAuthorizationViaEmail &&
                            editedCustomerSettings.fullEmailMarketingAllowed) ??
                          false
                        }
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="fullEmailMarketingAllowed"
                        Name="fullEmailMarketingAllowed"
                        IsRequired={false}
                        Label="Täysi email markkinointi (vain jos markkinointilupa annettu)"
                      />
                    </div>
                    <InputCheck
                      HandleChange={handleInputChangeCustomerSettings}
                      Id="marketingAuthorizationViaSms"
                      Name="marketingAuthorizationViaSms"
                      Checked={
                        editedCustomerSettings.marketingAuthorizationViaSms ??
                        false
                      }
                      IsRequired={false}
                      Label="Markkinointilupa sms"
                    />
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="officeFee"
                        Name="officeFee"
                        Checked={editedCustomerSettings.officeFee ?? false}
                        IsRequired={false}
                        Label="Toimitusmaksu"
                      />
                    </div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="travelAgencyCommission"
                        Name="travelAgencyCommission"
                        Value={
                          editedCustomerSettings.travelAgencyCommission ?? ''
                        }
                        IsRequired={false}
                        Label="Matkatoimisto komissio"
                      />
                    </div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="travelAgencyVat"
                        Name="travelAgencyVat"
                        Value={editedCustomerSettings.travelAgencyVat ?? ''}
                        IsRequired={false}
                        Label="Matkatoimisto Alv%"
                      />
                    </div>
                  </div>
                  <ActionButtons
                    CancelButtonUrl={backLinkUrl}
                    HandleSave={event => updateCustomerSettings(event)}
                  />
                </VerticalTabPane>
              )}
            {getIsCustomer() && editedVatSettings != null && (
              <VerticalTabPane IsActive={activeTab === Tabs[4]} Name={Tabs[4]}>
                <div>
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChangeVat}
                      Id="yCode"
                      Name="yCode"
                      Value={
                        editedVatSettings.yCode != null
                          ? editedVatSettings.yCode
                          : ''
                      }
                      IsRequired={false}
                      Label="Y-tunnus"
                    />
                  </div>
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChangeVat}
                      Id="hetu"
                      Name="hetu"
                      Value={
                        editedVatSettings.hetu != null
                          ? editedVatSettings.hetu
                          : ''
                      }
                      IsRequired={false}
                      Label="Hetu"
                    />
                  </div>
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChangeVat}
                      Id="otherVatCode"
                      Name="otherVatCode"
                      Value={
                        editedVatSettings.otherVatCode != null
                          ? editedVatSettings.otherVatCode
                          : ''
                      }
                      IsRequired={false}
                      Label="Muu Alv tunnus"
                    />
                  </div>
                  <div className="mb-24">
                    <InputCheck
                      HandleChange={handleInputChangeVat}
                      Id="paysVat"
                      Name="paysVat"
                      Checked={editedVatSettings.paysVat}
                      IsRequired={false}
                      Label="Alv velvollinen"
                    />
                  </div>
                  <ActionButtons
                    CancelButtonUrl={backLinkUrl}
                    HandleSave={event => updateVatSettings(event)}
                  />
                </div>
              </VerticalTabPane>
            )}
            {getIsCustomer() === true && (
              <VerticalTabPane IsActive={activeTab === Tabs[5]} Name={Tabs[5]}>
                {customerBookingsLoadingStatus === LOADING_STATUS.IDLE &&
                  bookingListItems != null && (
                    <div>
                      <Table>
                        <thead>
                          <tr>
                            <th>Nimi</th>
                            <th>Aika</th>
                            <th>Asiakas</th>
                            <th>Kohde</th>
                            <th>Tila</th>
                            <th>Hinta</th>
                            <th>Ostohinta</th>
                          </tr>
                        </thead>
                        <tbody>{bookingListItems}</tbody>
                      </Table>
                      <PaginationComponent
                        OnPageClick={handlePaginationClickCustomers}
                        PaginationData={customerBookingsPagination}
                      />
                    </div>
                  )}
              </VerticalTabPane>
            )}
          </VerticalTabs>
        )}
        <Modal show={isAddressModalVisible} backdrop="static">
          <Modal.Header>
            <Modal.Title>Muokkaa osoitetta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="postStreetAddress" className="mb-24">
              <Form.Label>Katuosoite</Form.Label>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.streetAddress && (
                  <div>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {mystate.webshopCustomer.streetAddress}
                    </div>
                  </div>
                )}
              <Form.Control
                name="postStreetAddress"
                value={editedAddress.postStreetAddress ?? ''}
                onChange={handleInputChangeAddress}
              />
            </Form.Group>

            <Form.Group controlId="additionalAddressLine" className="mb-24">
              <Form.Label>Osoitteen lisärivi</Form.Label>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.additionalAddress && (
                  <div>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {mystate.webshopCustomer.additionalAddress}
                    </div>
                  </div>
                )}
              <Form.Control
                name="additionalAddressLine"
                value={editedAddress.additionalAddressLine ?? ''}
                onChange={handleInputChangeAddress}
              />
            </Form.Group>

            <Form.Group controlId="postCode" className="mb-24">
              <Form.Label>Postinumero</Form.Label>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.postalCode && (
                  <div>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {mystate.webshopCustomer.postalCode}
                    </div>
                  </div>
                )}
              <Form.Control
                name="postCode"
                value={editedAddress.postCode ?? ''}
                onChange={handleInputChangeAddress}
              />
            </Form.Group>

            <Form.Group controlId="postCity" className="mb-24">
              <Form.Label>Postitoimipaikka</Form.Label>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.postCity && (
                  <div>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {mystate.webshopCustomer.postCity}
                    </div>
                  </div>
                )}
              <Form.Control
                name="postCity"
                value={editedAddress.postCity ?? ''}
                onChange={handleInputChangeAddress}
              />
            </Form.Group>
            <Form.Group className="mb-24">
              <Form.Label>Maa</Form.Label>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.countryId && (
                  <div>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {
                        countryOptions.filter(
                          option =>
                            option.value.toUpperCase() ===
                            mystate.webshopCustomer.countryId.toUpperCase(),
                        )[0].label
                      }
                    </div>
                  </div>
                )}
              <Select
                inputId="countryId"
                name="countryId"
                placeholder="Valitse maa"
                isClearable
                isSearchable
                options={countryOptions}
                onChange={option => handleSelectChange(option, 'countryId')}
                value={countryOptions.filter(
                  option => option.value === editedAddress.countryId,
                )}
                classNames={{
                  control: state => 'form-control form-control-react-select',
                }}
              />
            </Form.Group>

            <Form.Check
              className="my-24"
              label="Oletusosoite ?"
              id="isPrimary"
              name="isPrimary"
              onChange={handleInputChangeAddress}
              inline
              checked={editedAddress.isPrimary}
            />
          </Modal.Body>
          <Modal.Footer>
            <span className="text-danger">Muista tallentaa muutokset !</span>
            <Button
              variant="link"
              onClick={() => setIsAddressModalVisible(false)}
            >
              Sulje
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={isPhoneModalVisible} backdrop="static">
          <Modal.Header>
            <Modal.Title>Muokkaa puhelinnumeroa</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="phoneNumber" className="mb-24">
              <Form.Label>Puhelinnumero</Form.Label>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.phoneNumber && (
                  <div>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {mystate.webshopCustomer.phoneNumber}
                    </div>
                  </div>
                )}
              <Form.Control
                name="phoneNumber"
                value={editedPhone.phoneNumber ?? ''}
                onChange={handleInputChangePhone}
              />
            </Form.Group>

            <Form.Group controlId="description" className="mb-24">
              <Form.Label>Kuvaus</Form.Label>
              <Form.Control
                name="description"
                value={editedPhone.description ?? ''}
                onChange={handleInputChangePhone}
              />
            </Form.Group>
            <Form.Check
              className="my-24"
              label="Oletusnumero ?"
              id="isPrimary"
              name="isPrimary"
              onChange={handleInputChangePhone}
              inline
              checked={editedPhone.isPrimary}
            />
          </Modal.Body>
          <Modal.Footer>
            <span className="text-danger">Muista tallentaa muutokset !</span>
            <Button
              variant="link"
              onClick={() => setIsPhoneModalVisible(false)}
            >
              Sulje
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={isEMailModalVisible} backdrop="static">
          <Modal.Header>
            <Modal.Title>Muokkaa sähköpostiosoitetta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="emailAddress" className="mb-24">
              <Form.Label>Sähköposti</Form.Label>
              {mystate != null &&
                mystate.webshopCustomer !== null &&
                mystate.webshopCustomer !== undefined &&
                mystate.webshopCustomer.email && (
                  <div>
                    Verkkokaupan tiedot:
                    <div className="text-danger">
                      {mystate.webshopCustomer.email}
                    </div>
                  </div>
                )}
              <Form.Control
                name="emailAddress"
                value={editedEmail.emailAddress ?? ''}
                onChange={handleInputChangeEmail}
              />
            </Form.Group>

            <Form.Group controlId="description" className="mb-24">
              <Form.Label>Kuvaus</Form.Label>
              <Form.Control
                name="description"
                value={editedEmail.description ?? ''}
                onChange={handleInputChangeEmail}
              />
            </Form.Group>

            <Form.Check
              className="my-24"
              label="Oletus sähköposti ?"
              id="isPrimary"
              name="isPrimary"
              onChange={handleInputChangeEmail}
              inline
              checked={editedEmail.isPrimary}
            />
          </Modal.Body>
          <Modal.Footer>
            <span className="text-danger">Muista tallentaa muutokset !</span>
            <Button
              variant="link"
              onClick={() => setIsEMailModalVisible(false)}
            >
              Sulje
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
}
export default CustomerDetails;
